import { z } from 'zod'

export const SuspendParser = z.object({
  data: z.object({
    message: z.string()
  })
})

export const OpsConsoleSuspendParser = z.object({
  message: z.string()
})

export type DDESuspendFields = {
  urlOverride?: string
  token: string
  suspend: string
  operatorId: string
  licenseProperty: string
}

export type DDESuspendResponse = z.infer<typeof SuspendParser>
